import { Components } from "appworks/components/components";
import { FadeIn } from "appworks/graphics/animation/base-animations";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { gameState } from "appworks/model/game-state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { IsTGRFreespinsTriggered } from "decisions/is-tgr-freespins-triggered";
import { EpicUIColourComponent } from "epic/components/epic-ui-colour-component";
import { gameLayers } from "game-layers";
import { PartnerConnectRestoreSpinCommand } from "partner-connect/commands/partner-connect-restore";
import { PartnerConnectRecoverySpin } from "partner-connect/states/partner-connect-recovery-spin";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import { InFreespins } from "slotworks/state-machine/standard/decisions/in-freespins";

export class TGRRecoverySpin extends PartnerConnectRecoverySpin {

    protected startSpinning(): Contract<any> {
        return new Sequence([
            () => new Parallel([
                () => StartSpinCommand(),
                () => PartnerConnectRestoreSpinCommand()
            ]),
            () => Contract.wrap(() => gameState.getCurrentGame().isRecovered = false),
            () => this.restoreUI()
        ]);
    }

    protected restoreUI(): Contract<any> {
        const parallels = [];

        if (new InFreespins().evaluate() && !(new IsTGRFreespinsTriggered().evaluate())) {

            uiFlags.set(UIFlag.FREE_SPINS, true);

            const fsSprite = gameLayers.Background.getSprite("bg_fs");
            fsSprite.alpha = 0;
            fsSprite.visible = true;

            parallels.push(() => FadeIn(fsSprite, 1000));

            const fsSpine: SpineContainer = gameLayers.Background.getSpine("fs_spine");
            fsSpine.alpha = 0;
            fsSpine.visible = true;
            fsSpine.play("loop");

            parallels.push(
                () => FadeIn(fsSpine, 1000),
                () =>  Components.get(EpicUIColourComponent).adjustFade(80, 2, 1, 1000)
            );
        }

        return new Parallel(parallels);
    }
}
